import styled from 'styled-components';
import TxtField01 from 'dc/TxtField01';
import TxtField02 from 'dc/TxtField02';
import Btn021 from 'dc/Btn021';
import Btn020 from 'dc/Btn020';
import { Typ20 } from 'dc/Typ';

export const Form = styled.form`
  text-align: center;
  width: 288px;
  margin-top: 16px;
`;

export const Input = styled(TxtField01)`
  width: 100%;
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px #f4f7f9 inset !important;
  }
  input {
    background: #fff;
  }
`;

export const PasswordInput = styled(TxtField02)`
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px #f4f7f9 inset !important;
  }
  input {
    background: #fff;
  }
`;

export const Text = styled(Typ20)`
  padding: 0 16px;
`;

export const OtherButton = styled(Btn020)`
  margin-bottom: 15px;
  width: 288px;
  height: 48px;
  span {
    display: inline-block;
    color: #007079;
    text-decoration: underline;
    text-transform: lowercase;
    font-size: 14px;
    line-height: 21px;
  }
  span:first-letter {
    text-transform: capitalize;
  }
`;

export const LoginButton = styled(Btn021)`
  width: 100%;
  margin-bottom: 14px;
`;
